module.exports = __webpack_public_path__ + "static/img/pic4.40c719a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic4.png
// module id = l0S9
// module chunks = 0